import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forLifeOf, LifecycleAware } from '@lsq-frontend/common-ui';
import { getRouterLinkById } from '@lsq-frontend/common-ui';
import { filter } from 'rxjs/operators';
import { FastTrackRouteQueryParams } from '@lsq-frontend/fasttrack-shared/app-constants';
import { atlas, MOBILE_UPLOADS } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import {
    VerifyMobileUploadTokenRequest,
    VerifyMobileUploadTokenService
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';

@LifecycleAware()
@Component({
    selector: 'mobile-upload-token',
    template: `
        <div class="mobile-upload-token">
            <lsq-circle-loader></lsq-circle-loader>
        </div>
    `
})
export class MobileUploadTokenComponent implements OnInit, OnDestroy {
    constructor(
        private _route: ActivatedRoute,
        private _router: Router,
        private _userService: UserService,
        private _verifyMobileUploadTokenService: VerifyMobileUploadTokenService
    ) {}

    public async ngOnInit(): Promise<void> {
        const queryParamMap = this._route.snapshot.queryParamMap;
        const token = queryParamMap.get(FastTrackRouteQueryParams.Token);

        const mobileUploadQueryParams = {};
        mobileUploadQueryParams[FastTrackRouteQueryParams.InvoiceBatchKey] = queryParamMap.get(
            FastTrackRouteQueryParams.InvoiceBatchKey
        );

        this._userService.user$
            .pipe(
                forLifeOf(this),
                filter((user) => !!user)
            )
            .subscribe(() => {
                this._router.navigate(getRouterLinkById(atlas, MOBILE_UPLOADS), {
                    queryParams: mobileUploadQueryParams
                });
            });

        await this._verifyMobileUploadTokenService
            .executeOnce(new VerifyMobileUploadTokenRequest({ token }))
            .then((response) => {
                this._userService.authenticateToken(response.token);
            });
    }

    public ngOnDestroy(): void {}
}
